<template>
  <base-overlay :show="fetchingViolation">
    <b-card>
      <validation-observer ref="createRef">
        <b-form @submit.prevent="submit">
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Name English"
                rules="required"
              >
                <b-form-group
                  label="Name English"
                  label-for="name-en"
                >
                  <b-form-input
                    id="name-en"
                    v-model="formData.name"
                    maxlength="80"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Name Arabic"
                rules="required"
              >
                <b-form-group
                  label="Name Arabic"
                  label-for="name-ar"
                >
                  <b-form-input
                    id="name-ar"
                    v-model="formData.name_ar"
                    maxlength="80"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="12"
              class="mb-1 d-flex align-items-center justify-content-between"
            >
              <h2>Repetitions</h2>
              <b-button
                variant="primary"
                @click="addNewAction"
              >
                Add new repetition
              </b-button>
            </b-col>
            <b-col
              v-for="(value, key, index) in formData.metadata.actions"
              :key="index + key"
              md="12"
            >
              <div
                class="d-flex align-items-center mb-1"
              >
                <h4 class="mb-0">
                  Repetition {{ index + 1 }} {{ index == 0 ? '(Default)': '' }}
                </h4>
                <b-button
                  v-if="index != 0"
                  class="btn-icon rounded-circle"
                  variant="flat-danger"
                  @click="deleteRep(key)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </div>
              <b-row class="d-flex mb-2">
                <b-col
                  v-for="action in formData.metadata.actions[key]"
                  :key="`action-${key + action.action}`"
                  md="3"
                >
                  <b-form-checkbox
                    v-model="action.selected"
                    class="mb-1"
                  >
                    {{ snakeCaseToCamelCase(action.action) }}
                  </b-form-checkbox>
                  <template v-if="action.selected">
                    <template v-if="action.action == ACTIONS.NOTIFICATION">
                      <validation-provider
                        #default="{ errors }"
                        :name="`Notification Title rep-${index + 1}`"
                        rules="required"
                      >
                        <b-form-group
                          label="Notification Title"
                          :label-for="`notification-title-${index}`"
                        >
                          <b-form-input
                            :id="`notification-title-${index}`"
                            v-model="action.notification.title"
                          />
                          <span class="text-danger"> {{ errors[0] }} </span>
                        </b-form-group>
                      </validation-provider>
                      <validation-provider
                        #default="{ errors }"
                        :name="`Notification Description rep-${index + 1}`"
                        rules="required"
                      >
                        <b-form-group
                          label="Notification Description"
                          :label-for="`notification-desc-${index}`"
                        >
                          <b-form-textarea
                            :id="`notification-desc-${index}`"
                            v-model="action.notification.description"
                          />
                          <span class="text-danger"> {{ errors[0] }} </span>
                        </b-form-group>
                      </validation-provider>
                    </template>
                    <template v-if="action.action == ACTIONS.DEDUCT">
                      <validation-provider
                        #default="{ errors }"
                        :name="`Deduct Amount rep-${index + 1}`"
                        rules="required"
                      >
                        <b-form-group
                          label="Deduct Amount"
                          :label-for="`deduct-amount-${index}`"
                        >
                          <b-form-input
                            :id="`deduct-amount-${index}`"
                            v-model.number="action.amount"
                            type="number"
                          />
                          <span class="text-danger"> {{ errors[0] }} </span>
                        </b-form-group>
                      </validation-provider>
                    </template>
                    <template v-if="action.action == ACTIONS.AUTO_RESOLVE_BLOCK">
                      <validation-provider
                        #default="{ errors }"
                        :name="`Resolve After Unit rep-${index + 1}`"
                        rules="required"
                      >
                        <b-form-group
                          label="Resolve After Unit"
                          :label-for="`resolve-after-unit-${index}`"
                        >
                          <b-form-select
                            :id="`resolve-after-unit-${index}`"
                            v-model="action.resolve_after_unit"
                            :options="RESOLVE_IN_OPTIONS"
                            @change="action.hours = null"
                          />
                          <span class="text-danger"> {{ errors[0] }} </span>
                        </b-form-group>
                      </validation-provider>
                      <validation-provider
                        #default="{ errors }"
                        rules="required"
                        :name="`Resolve After Value rep-${index + 1}`"
                      >
                        <b-form-group
                          label="Resolve After Value"
                          :label-for="`resolve-after-${index}`"
                        >
                          <b-input-group
                            :append="action.resolve_after_unit"
                          >
                            <b-form-input
                              :id="`resolve-after-${index}`"
                              v-model="action.hours"
                              type="number"
                            />
                          </b-input-group>
                          <span class="text-danger"> {{ errors[0] }} </span>
                        </b-form-group>
                      </validation-provider>
                    </template>
                    <template v-if="action.action === ACTIONS.BLOCK">
                      <validation-provider
                        #default="{ errors }"
                        rules="required"
                        :name="`Block Reason rep-${index + 1}`"
                      >
                        <b-form-group
                          label="Block Reason"
                          :label-for="`block-reason-${index}`"
                        >
                          <b-form-radio-group
                            :id="`block-reason-${index}`"
                            v-model="action.reason"
                            stacked
                            :options="blockingReasons"
                          />
                          <span class="text-danger"> {{ errors[0] }} </span>
                        </b-form-group>
                      </validation-provider>
                    </template>
                  </template>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="4">
              <b-button
                block
                variant="primary"
                type="submit"
                :disabled="submitting"
              >
                <b-spinner
                  v-if="submitting"
                  small
                />
                <span v-else>Save</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </base-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup, BFormInput, BForm,
  BRow, BCol, BCard, BButton, BSpinner,
  BFormRadioGroup,
  BFormCheckbox, BFormSelect, BInputGroup, BFormTextarea,
} from 'bootstrap-vue'
import { required } from '@validations'
import { ref, set } from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import { errorNotification } from '@/utils/toast-notifications'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'

const ACTIONS = {
  NOTIFICATION: 'notification',
  BLOCK: 'block',
  AUTO_RESOLVE_BLOCK: 'auto_resolve_block',
  DEDUCT: 'deduct',
}

const RESOLVE_IN = {
  DAYS: 'Days',
  HOURS: 'Hours',
}
const RESOLVE_IN_OPTIONS = ['Days', 'Hours']

const blockingReasons = ['Permanent', 'Penalty', 'Update', 'Deactivate']

export default {
  components: {
    ValidationProvider,
    BInputGroup,
    ValidationObserver,
    BFormGroup,
    BFormSelect,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    BFormRadioGroup,
    BaseOverlay,
    BFormInput,
    BRow,
    BCol,
    BForm,
    BButton,
    BSpinner,
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, ctx) {
    const violationID = ctx.root.$route.params.id

    const formData = ref({
      name: '',
      name_ar: '',
      metadata: {
        actions: {},
      },
    })

    const addNewAction = () => {
      const randomID = Math.random().toString()

      set(formData.value.metadata.actions, randomID, [
        {
          action: ACTIONS.NOTIFICATION,
          selected: false,
          notification: {
            title: '',
            description: '',
          },
        },
        {
          action: ACTIONS.AUTO_RESOLVE_BLOCK,
          hours: null,
          resolve_after_unit: RESOLVE_IN.DAYS,
          selected: false,
        },
        {
          action: ACTIONS.DEDUCT,
          selected: false,
          amount: null,
        },
        {
          action: ACTIONS.BLOCK,
          reason: null,
          selected: false,
        },
      ])
    }

    addNewAction()

    const setFullActions = arr => {
      const hasNotification = arr.find(el => el.action === ACTIONS.NOTIFICATION)
      const hasResolveBlock = arr.find(el => el.action === ACTIONS.AUTO_RESOLVE_BLOCK)
      const hasDeduct = arr.find(el => el.action === ACTIONS.DEDUCT)
      const hasBlock = arr.find(el => el.action === ACTIONS.BLOCK)

      return [{
        action: ACTIONS.NOTIFICATION,
        selected: !!hasNotification,
        notification: {
          title: hasNotification ? hasNotification.notification.title : '',
          description: hasNotification ? hasNotification.notification.description : '',
        },
      },
      {
        action: ACTIONS.AUTO_RESOLVE_BLOCK,
        selected: !!hasResolveBlock,
        hours: hasResolveBlock ? hasResolveBlock.hours : null,
        resolve_after_unit: hasResolveBlock ? hasResolveBlock.resolve_after_unit : null,
      },
      {
        action: ACTIONS.DEDUCT,
        selected: !!hasDeduct,
        amount: hasDeduct ? hasDeduct.amount : null,
      },
      {
        action: ACTIONS.BLOCK,
        selected: !!hasBlock,
        reason: hasBlock ? hasBlock.reason : null,
      },
      ]
    }

    const deleteRep = key => {
      ctx.root.$set(formData.value.metadata.actions, key, undefined)
      delete formData.value.metadata.actions[key]
    }

    const fetchingViolation = ref(false)
    const fetchViolation = async () => {
      fetchingViolation.value = true
      const result = await axiosIns.get(`/drivers/violations/types/${violationID}`)
      const { data } = result.data

      formData.value.name = data.name
      formData.value.name_ar = data.name_ar
      const actionsObj = data.metadata.actions
      const firstAction = setFullActions(actionsObj.default)
      delete actionsObj.default

      Object.keys(actionsObj).forEach(key => {
        actionsObj[key] = setFullActions(actionsObj[key])
      })

      formData.value.metadata.actions = {
        0: firstAction,
        ...actionsObj,
      }
      fetchingViolation.value = false
    }
    if (violationID && !props.isNew) {
      fetchViolation()
    }

    const submitting = ref(false)
    const submit = async () => {
      const res = await ctx.refs.createRef.validate()
      if (!res) return

      const actionsObj = JSON.parse(JSON.stringify(formData.value.metadata.actions))

      let firstKey

      Object.keys(actionsObj).forEach((key, ix) => {
        if (ix === 0) {
          firstKey = key
        }
        actionsObj[key] = actionsObj[key].filter(action => {
          const isSelected = action.selected
          if (action.action === ACTIONS.AUTO_RESOLVE_BLOCK && isSelected) {
            if (action.resolve_after_unit === RESOLVE_IN.DAYS) {
              // eslint-disable-next-line no-param-reassign
              action.hours *= 24
            }
          }
          // eslint-disable-next-line no-param-reassign
          delete action.selected
          return isSelected
        })
      })

      const isOneActionNotFilled = Object.values(actionsObj).some(arr => arr.length === 0)
      if (isOneActionNotFilled) {
        errorNotification('Check at least one option in a repetition')
        return
      }

      const defaultAction = JSON.parse(JSON.stringify(actionsObj[firstKey]))
      delete actionsObj[firstKey]

      // This is for keeping the sequence after default key as 1,2,3 in case of deletion happens
      const actionsKeys = Object.keys(actionsObj)
      const restOfActions = {}

      actionsKeys.forEach((key, ix) => {
        restOfActions[ix + 1] = actionsObj[key]
      })

      const requestPayload = {
        name: formData.value.name,
        name_ar: formData.value.name_ar,
        metadata: {
          actions: {
            default: defaultAction,
            ...restOfActions,
          },
        },
      }
      try {
        submitting.value = true
        if (props.isNew) {
          await axiosIns.post('/drivers/violations/types', requestPayload)
        } else {
          await axiosIns.patch(`/drivers/violations/types/${violationID}`, requestPayload)
        }
        ctx.root.$router.push('/violations')
      } catch (err) {
        const { error } = err.response.data
        if (error) {
          const values = Object.values(error)
          const errMsg = values[0][0]
          errorNotification(errMsg)
        }
        console.log(err.response)
      } finally {
        submitting.value = false
      }
    }
    return {
      required,
      deleteRep,
      ACTIONS,
      submitting,
      RESOLVE_IN,
      blockingReasons,
      RESOLVE_IN_OPTIONS,
      fetchingViolation,
      snakeCaseToCamelCase,
      addNewAction,
      formData,
      submit,
    }
  },
}
</script>
